// 学生激活验证不通过 提示核对信息弹框 公用
import { Message} from 'element-ui'
export default {
    PleaseCheck:function(){
                    Message.error({
                        message:"请核对填写信息！",
                        type:"error",
                        duration:3000
                })
            }
}


// WEBPACK FOOTER //
// ./src/assets/js/pleaseCheck.js